/** A custom PDFTron tool base class to handle stamps. */
class BaseStampTool extends Core.Tools.GenericAnnotationCreateTool {
    protected base64Image: string;
    private width: number;
    private height: number;

    constructor(viewer: Core.DocumentViewer, name: string, width: number, height: number) {
        super(viewer, Core.Annotations.StampAnnotation as unknown as Core.Annotations.Annotation);
        this.name = name;
        this.width = width;
        this.height = height;
        delete this.defaults.StrokeColor;
        delete this.defaults.FillColor;
        delete this.defaults.StrokeThickness;
    }

    // Override mouseLeftDown
    public mouseLeftDown(...args: any[]): void {
        Core.Tools.AnnotationSelectTool.prototype.mouseLeftDown.apply(this, args);
    }

    // Override mouseMove
    public mouseMove(...args: any[]): void {
        Core.Tools.AnnotationSelectTool.prototype.mouseMove.apply(this, args);
    }

    // Override mouseLeftUp
    public mouseLeftUp(e: any): void {
        super.mouseLeftDown(e);

        const annotation = this.annotation as Core.Annotations.StampAnnotation;
        if (annotation)
            BaseStampTool.setStampAnnotationImage(annotation, this.base64Image, this.getDocumentViewer(), this.width, this.height);

        super.mouseLeftUp(e);

        if (annotation)
            this.getDocumentViewer().getAnnotationManager().redrawAnnotation(annotation);
    }

    /**
     * Configure a stamp annotation to display an image.
     * @param annotation The annotation
     * @param base64Image The image of the annotation in base64
     * @param documentViewer The current document viewer
     * @param width The width of the annotation
     * @param height The height of the annotation
     */
    private static setStampAnnotationImage(
        annotation: Core.Annotations.StampAnnotation,
        base64Image: string,
        documentViewer: Core.DocumentViewer,
        width: number,
        height: number
    ): void {
        const rotation = documentViewer.getCompleteRotation(annotation.PageNumber) * 90;
        annotation.Rotation = rotation;

        if (rotation === 270 || rotation === 90) {
        // swap dimensions
            [height, width] = [width, height];
        }

        annotation.setImageData(base64Image, true);
        annotation.Width = width;
        annotation.Height = height;
        annotation.X -= width / 2;
        annotation.Y -= height / 2;
        annotation.MaintainAspectRatio = true;
    }
}

/** Common styles for stamps created through custom stamp tools. */
const StampStyles = {
    primaryColor: "#0A5BAD",
    fontFamily: "Candara",
    background: "rgba(255, 255, 255, 0.01)"
};

export { BaseStampTool, StampStyles };
